// Library Imports
import React from 'react';
import ReactDOM from 'react-dom/client';
// Component Imports
import App from './App';
// Asset Imports
import './assets/css/base/index.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'typeface-roboto'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);
